import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router"
import styled from "styled-components"
import { post, get } from "../../../netApi/fetch"
import SendBtnImg from "./../../../images/sendBtn.png"
import imageUpload, { imageType } from "../../../methods/imageUpload"
import { Dropdown, message } from "antd"
import { confirm } from "../../Method/Confirm"

// 创建样式组件
const InputContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 884px;
  border: 1px solid rgb(240 240 240);
  border-radius: 20px;
  padding: 12px;
  background: rgba(255, 255, 255, 1);
`

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 780px;
  margin: 20px auto;
  border: 1px solid rgb(240 240 240);
  border-radius: 20px;
  padding: 12px;
  :hover {
    box-shadow: 0px 2px 10px 5px rgba(232, 232, 232, 0.5);
  }
  background: rgba(255, 255, 255, 1);
  transition:
    opacity 0.3s,
    transform 0.3s,
    box-shadow 0.3s;
  animation: fadeIn 0.3s forwards;
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const TextArea = styled.textarea`
  width: calc(100% - 30px);
  min-height: 120px;
  border: none;
  outline: none;
  resize: none;
  font-size: 16px;
  font-family: inherit;
  padding: 0;
  margin: 15px;
  margin-bottom: 40px;
  background: rgba(255, 255, 255, 1);

  &::placeholder {
    color: #aaa;
  }
`

const ContentArea = styled.div`
  width: calc(100% - 30px);
  height: 130px;
  border: none;
  outline: none;
  resize: none;
  font-size: 16px;
  font-family: inherit;
  padding: 0;
  margin: 15px;
  margin-bottom: 40px;
  overflow: hidden;

  .p {
    color: rgba(69, 69, 69, 1);
    font-family: Source Han Sans CN;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    // 自然换行
    word-break: break-word;
    white-space: pre-wrap;
  }
`

const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 12px;
  left: 12px;
  right: 12px;
`

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 12px;
  }
`

const ImageUploadButton = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid rgb(240 240 240);
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgb(240 240 240);
  }

  input {
    display: none;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: #666;
  }
`

const SendButton = styled.button`
  padding: 8px;
  background: ${(props) => (props.disabled ? "#ccc" : "var(--theme-main)")};
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background: ${(props) => (props.disabled ? "#ccc" : "var(--theme-main-hover-light)")};
  }
`

const GenerateMp4Button = styled.button`
  border-radius: 50px;
  border: 1px solid var(--theme-main);
  background-color: #fff;
  color: var(--theme-main);
  padding: 5px 10px;
  font-size: 12;

  &:hover {
    background: ${(props) => (props.disabled ? "#ccc" : "var(--theme-main-hover-light)")};
  }
`

const MoreButton = styled.button`
  border: none;
  background: transparent;
  color: #999;
  font-size: 18px;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #f5f5f5;
    color: #666;
  }
`

const LoadingText = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  max-width: 300px;
  margin: 20px auto;
  display: block;
  text-align: center;
  color: #ccc;
`

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main, #3498db);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

// function DialogPage(props: { user: user; loginBindInfo: loginBindInfo }) {
function DialogPage(props) {
  const isLogin = props.user && props.user.uid
  const router = useHistory()
  
  // 检查地址栏参数决定是否恢复缓存
  const shouldRestoreCache = localStorage.getItem('restore_content_edit_cache') === '1'
  
  // if (props.user.is_branch) {
  //   router.replace("/index/mall/goods/2")
  // }
  const [inputValue, setInputValue] = useState("") // 输入
  const [selectedImages, setSelectedImages] = useState<imageType[]>([]) // 选中的图片
  const [viewOffsetIndex, setViewOffsetIndex] = useState(() => {
    if (shouldRestoreCache) {
      const saved = localStorage.getItem('contentPage_viewOffsetIndex')
      return saved ? parseInt(saved) : 0
    }
    return 0
  }) // 分页加载
  const [viewLength, setViewLength] = useState<number>(() => {
    if (shouldRestoreCache) {
      const saved = localStorage.getItem('contentPage_viewLength')
      return saved ? parseInt(saved) : null
    }
    return null
  }) // 总条数
  const [sendTime, setSendTime] = useState(() => {
    if (shouldRestoreCache) {
      const saved = localStorage.getItem('contentPage_sendTime')
      return saved ? parseInt(saved) : 0
    }
    return 0
  }) // 发送次数
  const [contentList, setContentList] = useState(() => {
    if (shouldRestoreCache) {
      const saved = localStorage.getItem('contentPage_contentList')
      return saved ? JSON.parse(saved) : []
    }
    // 如果不需要恢复缓存，立即清理并返回空数组
    localStorage.removeItem('contentPage_contentList')
    return []
  }) // 内容
  const [isLoading, setIsLoading] = useState(false) // 加载状态
  const [isRestoring, setIsRestoring] = useState(shouldRestoreCache) // 缓存恢复状态
  const limit = 10 // 每次加载条数
  const arrivedBottom = () => {
    // 到达底部
    if (viewLength == null) return false
    return viewOffsetIndex * limit + sendTime >= viewLength
  }

  // 检查是否滚动到底部的函数
  const isScrollToBottom = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    return scrollTop + clientHeight >= scrollHeight - 50 // 提前50px开始加载
  }

  // 滚动事件处理器
  const handleScroll = () => {
    if (isScrollToBottom() && !arrivedBottom() && !isLoading && isLogin) {
      handleGetContentList()
    }
  }

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      imageUpload(file, "content").then((res) => {
        console.log("res :>> ", res)
        setSelectedImages((lst) => [...lst, res])
      })
    }
  }

  const handleDelImg = (img: imageType) => {
    setSelectedImages((lst) => lst.filter((item) => item.id !== img.id))
  }

  /**
   *  获取内容列表
   *  @param {boolean} first 是否只取第一条
   */
  const handleGetContentList = (first: boolean = false) => {
    if (isLoading && !first) return // 防止重复请求

    const nowIndex = first ? 0 : viewOffsetIndex * limit + sendTime
    const lim = first ? 1 : limit
    console.log("viewOffsetIndex * limit + sendTime :>> ", viewOffsetIndex, limit, sendTime)
    console.log("nowIndex, viewCount :>> ", nowIndex, viewLength)
    console.log("viewOffsetIndex :>> ", viewOffsetIndex)
    if (viewLength != null && nowIndex >= viewLength + +first) return console.log("没有更多的了")

    !first && setIsLoading(true)
    const p = get(`/content/viewlist?offset=${nowIndex}&limit=${lim}`, {})
    !first && setViewOffsetIndex(prev => {
      const newValue = prev + 1
      localStorage.setItem('contentPage_viewOffsetIndex', newValue.toString())
      return newValue
    })
    p.then((res) => {
      setViewLength(prev => {
        localStorage.setItem('contentPage_viewLength', res.count.toString())
        return res.count
      })
      const newContentList = first ? [...res.list, ...contentList] : [...contentList, ...res.list]
      setContentList(newContentList)
      localStorage.setItem('contentPage_contentList', JSON.stringify(newContentList))
    }).finally(() => {
      !first && setIsLoading(false)
    })
  }

  useEffect(() => {
    // 清除地址栏参数，防止重复生效
    if (shouldRestoreCache) {
      localStorage.removeItem('restore_content_edit_cache')
    }
    
    // 如果需要恢复缓存且已有缓存的数据，平滑恢复滚动位置
    if (shouldRestoreCache && contentList.length > 0) {
      // 延迟恢复，给页面渲染时间
      setTimeout(() => {
        const savedScrollPosition = localStorage.getItem('contentPage_scrollPosition')
        if (savedScrollPosition) {
          // 使用平滑滚动
          window.scrollTo({
            top: parseInt(savedScrollPosition),
            behavior: 'smooth'
          })
        }
        // 恢复完成后隐藏加载状态
        setTimeout(() => {
          setIsRestoring(false)
        }, 500) // 给滚动动画时间
      }, 200) // 确保内容已渲染
    } else {
      // 如果不需要恢复缓存或没有缓存数据，则重新加载
      if (!shouldRestoreCache) {
        // 清理所有缓存
        localStorage.removeItem('contentPage_viewOffsetIndex')
        localStorage.removeItem('contentPage_viewLength')
        localStorage.removeItem('contentPage_sendTime')
        localStorage.removeItem('contentPage_contentList')
        localStorage.removeItem('contentPage_scrollPosition')
      }
      handleGetContentList()
      setIsRestoring(false) // 不需要恢复时直接隐藏加载状态
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 监听滚动事件
  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewOffsetIndex, viewLength, isLoading, isLogin, sendTime])

  const handleSend = () => {
    if (inputValue.trim() || selectedImages) {
      console.log("发送内容:", inputValue, "图片:", selectedImages)
      post("/content/create?app=jieligo", {
        title: "",
        content: inputValue,
        type: 1,
        image: selectedImages.map((i) => i.id).join(",") ?? "",
        imageids: selectedImages.map((i) => i.id),
      }).then((res) => {
        console.log("res :>> ", res)
        // 清理滚动位置缓存，因为新内容在顶部
        localStorage.removeItem('contentPage_scrollPosition')
        setSendTime(prev => {
          const newValue = prev + 1
          localStorage.setItem('contentPage_sendTime', newValue.toString())
          return newValue
        })
        handleGetContentList(true)
      })
      setInputValue("")
      setSelectedImages([])
    }
  }

  const handleContentClick = (item, generatedVideo = false) => {
    console.log("点击了内容:", item, "generatedVideo:", generatedVideo)
    // 保存当前滚动位置
    localStorage.setItem('contentPage_scrollPosition', window.scrollY.toString())
    if (generatedVideo) router.push(`/contentedit/${item.id}?auto_focus=generatedVideo`)
    else router.push(`/content/${item.id}`)
  }

  const handleMenuClick = (item, key, e) => {
    e.stopPropagation()
    switch (key) {
      case "edit":
        router.push(`/contentedit/${item.id}`)
        break
      case "generate":
        router.push(`/contentedit/${item.id}?auto_focus=generatedVideo`)
        break
      case "delete":
        confirm({
          text: "确定要删除吗？",
        }).then((res) => {
          if (res) {
            post("/content/delete", { id: item.id }).then(() => {
              message.success("删除成功")
              // 从列表中移除已删除的项目
              setContentList(prevList => {
                const newList = prevList.filter(listItem => listItem.id !== item.id)
                localStorage.setItem('contentPage_contentList', JSON.stringify(newList))
                return newList
              })
              // 更新总数
              setViewLength(prevLength => {
                const newValue = prevLength - 1
                localStorage.setItem('contentPage_viewLength', newValue.toString())
                return newValue
              })
            })
          }
        })
        break
    }
  }

  return (
    <>
      {/* 简洁的全屏加载遮罩 */}
      {isRestoring && (
        <LoadingOverlay>
          <LoadingSpinner />
        </LoadingOverlay>
      )}
      
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <div className="flex-center" style={{ flexWrap: "wrap" }}>
          <InputContainer>
            <TextArea placeholder="开始记录你的想法吧～" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
            <ControlsContainer>
              <LeftContainer>
                {/* <ImageUploadButton>
                  <input type="file" accept="image/*" onChange={handleImageUpload} multiple />
                  <svg viewBox="0 0 24 24">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                  </svg>
                  图片
                </ImageUploadButton> */}
                {/* 图片展示 */}
                {selectedImages.map((selectedImage) => (
                  <div style={{ position: "relative", display: "inline-block" }} key={selectedImage.id}>
                    {/* 右上角关闭按钮 */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "bold",
                        zIndex: 10,
                      }}
                      onClick={() => handleDelImg(selectedImage)} // 替换为你的关闭处理函数
                    >
                      ×
                    </div>

                    <img
                      src={selectedImage.url}
                      alt="Selected"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                ))}
              </LeftContainer>
              <SendButton onClick={handleSend} disabled={!inputValue.trim() && !selectedImages}>
                <img src={SendBtnImg} alt="发送" style={{ width: 20, height: 20, marginTop: -3 }} />
              </SendButton>
            </ControlsContainer>
          </InputContainer>
        </div>
      </div>
      {contentList.map((item) => {
        // {
        //   id: "10008",
        //   title: "",
        //   content: "1",
        //   type: "1",
        //   image: "",
        //   can_share: "0",
        //   show_read: "0",
        //   status: "1",
        //   createtime: "2025-09-05 13:51:29",
        //   uid: "1000849186",
        //   updatetime: "2025-09-05 13:51:29",
        //   views: "0",
        //   comments: "0",
        //   reads: "0",
        //   sid: "1000849185",
        //   images: [],
        // }
        return (
          <ContentContainer key={item.id} style={{ opacity: 0, transform: "translateY(-20px)" }} onClick={() => handleContentClick(item)}>
            <ContentArea>
              <span className="p">{item.content}</span>
            </ContentArea>
            <ControlsContainer style={{ left: 20 }}>
              <div style={{ color: "#ccc", fontSize: 12 }}>
                {item.createtime}
                {item.status === "2" && <span style={{ color: "var(--theme-main)", marginLeft: 10 }}>(生成中)</span>}
                {/* <text wx:if="{{item.mp4 && item.mp4.url}}" style="margin-left: 8rpx; flex-shrink: 0; color: #667eea; font-size: 22rpx; font-weight: 500;">▶</text> */}
                {item.mp4 && item.mp4.url && <span style={{marginLeft: 8, color: "#667eea", fontSize: 16, fontWeight: 500}}>▶</span>}
                <span style={{ fontSize: 14, fontWeight: 600 }}>&nbsp;&nbsp;&nbsp;{item.title || "无标题"}</span>
              </div>

              <div style={{ marginLeft: 10 }}>
                <Dropdown
                  menu={{
                    onClick: ({ key, domEvent }) => handleMenuClick(item, key, domEvent),
                    items: [
                      {
                        key: "generate",
                        label: "生成视频",
                      },
                      {
                        key: "edit",
                        label: "编辑",
                      },
                      {
                        key: "delete",
                        label: "删除",
                        style: { color: "#ff4d4f" },
                      },
                    ],
                  }}
                  trigger={["hover"]}
                  placement="topRight"
                >
                  <MoreButton onClick={(e) => e.stopPropagation()}>⋯</MoreButton>
                </Dropdown>
              </div>
            </ControlsContainer>
          </ContentContainer>
        )
      })}
      {/* 加载状态提示 */}
      {!arrivedBottom() && isLogin && <LoadingText>{isLoading ? "加载中..." : "滚动到底部加载更多"}</LoadingText>}
      {!isLogin && <LoadingText>请登录后查看</LoadingText>}
      {arrivedBottom() && isLogin && contentList.length > 0 && <LoadingText>已加载全部内容</LoadingText>}
    </>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DialogPage)
